var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.001,
    height: 38.001,
    viewBox: "0 0 38.001 38.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "STAR_QUALITY",
    "data-name": "STAR QUALITY",
    className: "cls-1",
    d: "M4296.482,7223l-8.529-4.668,3.488-7.3a.727.727,0,0,0-.143-.827.735.735,0,0,0-.832-.143l-7.3,3.488-4.666-8.531a.73.73,0,0,0-1.28,0l-4.663,8.531-7.3-3.488a.729.729,0,0,0-.965.987l3.645,7.2-8.7,4.754a.729.729,0,0,0,0,1.276l8.531,4.667-3.486,7.3a.728.728,0,0,0,.658,1.044.742.742,0,0,0,.314-.071l7.3-3.488,4.663,8.531a.73.73,0,0,0,1.28,0l4.666-8.531,7.3,3.488a.752.752,0,0,0,.315.071.728.728,0,0,0,.659-1.044l-3.488-7.3,8.529-4.667a.726.726,0,0,0,0-1.276Zm-13.062-5.952-4.83,4.832v-13.663Zm-6.288,4.832-4.828-4.832,4.828-8.831Zm-5.861-3.8,4.83,4.829h-13.66Zm4.83,6.287-4.83,4.83-8.831-4.83Zm-3.8,5.859,4.828-4.829v13.661Zm6.286-4.829,4.83,4.829-4.83,8.832Zm5.861,3.8-4.831-4.83h13.662Zm-4.831-6.288,4.831-4.829,8.831,4.829Zm9.617-10.644-2.565,5.367-1.814-.99-.991-1.814Zm-22.68.031,5.3,2.531-.994,1.814-1.65.9Zm-.07,22.715,2.564-5.369,1.811.992.994,1.814Zm22.75,0-5.37-2.562.991-1.814,1.814-.992Z",
    transform: "translate(-4258.861 -7204.634)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.46927f3a109a8842cb1a1db15a7e4c16.svg";
export { ForwardRef as ReactComponent };